import { createContext, useContext } from 'react';

/**
 * CONTROLES DE TELA — três comandos independentes, todos providos pelo Shell
 * (que é quem manda na sidebar e no painel direito):
 *
 *  - `sidesCollapsed` / `toggleSides`: as LATERAIS juntas (menu esquerdo em
 *    trilho de ícones + painel direito da agenda fechado), sem tocar no
 *    cabeçalho;
 *  - `headerCompact` / `toggleHeaderCompact`: o cabeçalho da ficha numa linha
 *    só (preferência salva por usuário);
 *  - `focus` / `toggleFocus`: os dois acima num clique (Alt+Z).
 *
 * `focus` e `sidesCollapsed` são DERIVADOS do estado real (sidebar, painel,
 * cabeçalho) — nenhum deles "força" nada. Assim cada botão continua
 * funcionando sozinho: com o foco ligado dá pra expandir só o menu, só o
 * painel ou só o cabeçalho, e o botão do foco simplesmente deixa de aparecer
 * como ativo.
 */
interface FocusModeValue {
  focus: boolean;
  toggleFocus: () => void;
  sidesCollapsed: boolean;
  toggleSides: () => void;
  headerCompact: boolean;
  toggleHeaderCompact: () => void;
}

export const FocusModeContext = createContext<FocusModeValue>({
  focus: false,
  toggleFocus: () => {},
  sidesCollapsed: false,
  toggleSides: () => {},
  headerCompact: false,
  toggleHeaderCompact: () => {},
});

export const useFocusMode = () => useContext(FocusModeContext);
